import React, { useState, useEffect } from "react";
import { Switch, Route, Redirect, useHistory } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";
import Login from "../Login";
import Home from "../Home";

import Sites from "../Sites";
import SiteDetail from "../SiteDetail";
import SiteEdit from "../SiteEdit";
import Map from "../Map";
import MapComponent from "../MapComponent";
import TrafficScanning from "../TrafficScanning";
import EstimateEBITDATC from "../EstimateEBITDATC";

import api from "../../api";
import MarketInformation from "../MarketInfomation";
import MarketInformationEdit from "../MarketInformationEdit";
import MarketInformationDetail from "../MaketInformationDetail";

import Portal from "../Portal";
import PortalSuccess from "../PortalSuccess";
import ExternalSiteEdit from "../ExternalSiteEdit";
import ExternalSites from "../ExternalSites";
import ExternalSiteDetail from "../ExternalSiteDetail";
import ResetPassword from "../ResetPassword";
import StoreEdit from "../Store/pages/StoreEdit";
import StoreListing from "../Store/pages/StoreListing";
import StoreDetail from "../Store/pages/StoreDetail";

import SiteV2Detail from "../Site/pages/SiteDetail";
import SiteV2Edit from "../Site/pages/SiteEdit";
import SiteEstimateEBITDATC from "../Site/pages/EstimateEBITDATC";

import SiteComparison from "../SiteComparison/pages/";
import SiteTrafficCounting from "../SiteTrafficCounting/pages";
import GoogleMap from "pages/Map";
import StorePlanningMap from "../StorePlanning/pages/PlanningMap";
import PagePath from "common/PagePath";
import MainWrapper from "./Layout";
import ShareComponent from "pages/ShareComponent";
import { componentRoutes } from "shared/utils/routes";
import SiteManager from "pages/Site/pages/SiteManager";
// import Sidebar from "pages/ShareComponent/Sidebar";
import StorePlanningList from "../StorePlanning/pages/PlanningList";

import ZoneElement from "../ZoneAssignment/pages/ZoneElement";

import UserListing from "../Users/pages/UserListing";

import Settings from "pages/Settings/pages/MainSettings";
import StatusManagement from "pages/StatusManagement";
import PlanningMap from "../StorePlanning/pages/PlanningMap";

import Help from "../Help";
import StoreManager from "pages/Store/pages/StoreManager";
import CustomTabs from "pages/CustomField/containers/CustomTabs";
import CustomTabDetail from "pages/CustomField/containers/CustomTabDetail";
import IFRS from "pages/ifrs";
import Contract from "pages/Contract";
import IFRSDetail from "pages/ifrsDetail";
import Revenue from "pages/Revenue";
import ApiCaller from "api/apiCaller";

import Cookies from "js-cookie";
import ActionTypes from "actions/ActionTypes";
import { createErrorMessageSelector } from "reducers/selectors";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserProfile } from "actions/UserActions";

const errorSelector = createErrorMessageSelector([ActionTypes.USER_PREFIX]);

// The Main component renders one of the three provided
// Routes (provided that one matches). Both the /roster
// and /schedule routes will match any pathname that starts
// with /roster or /schedule. The / route will only match
// when the pathname is exactly the string "/"
//https://medium.com/@pshrmn/a-simple-react-router-v4-tutorial-7f23ff27adf

// For loggin handling, use component={CheckForLogIn}
// This ensure that all the pages required log in will be run AFTER our login logic
// https://medium.com/the-many/adding-login-and-authentication-sections-to-your-react-or-react-native-app-7767fd251bd1

interface PrivateRouteProps {
  component: any;
}

function PrivateRoute({ component: Component, ...rest }: PrivateRouteProps) {
  const history = useHistory();
  const error = useSelector((state) => errorSelector(state));
  const dispatch = useDispatch();
  const [authenticating, setAuthenticating] = useState(true);
  const [authed, setAuthed] = useState(false);
  const [haraworksToken, setHaraworksToken] = useState<string | null>("");
  const [detectingHaraworks, setDetectHaraworks] = useState(true);
  const handleLoginData = async (res: any) => {
    await Cookies.set("access_token", res?.access_token, {
      expires: 7,
      sameSite: "None",
      secure: true,
    });
    await Cookies.set("refresh_token", res?.refresh_token, {
      expires: 7,
      sameSite: "None",
      secure: true,
    });
    if (res?.user) {
      const userRes = res.user;
      await Cookies.set("email", userRes?.email, {
        expires: 7,
        sameSite: "None",
        secure: true,
      });
      await Cookies.set("first_name", userRes?.first_name, {
        expires: 7,
        sameSite: "None",
        secure: true,
      });
      await Cookies.set("current_user_id", userRes?.id, {
        expires: 7,
        sameSite: "None",
        secure: true,
      });
    }
    gotoPage();
  };
  const authUserFromHRW = async () => {
    const res = await ApiCaller.post(
      `user/hrw/external/login?haraworks_token=${haraworksToken}`
    );
    if (res.status === "fail") {
      alert(res.message);
    } else {
      handleLoginData(res);
    }
  };
  const gotoPage = async () => {
    await dispatch(fetchUserProfile());
    setAuthenticating(false);
  };
  useEffect(() => {
    if (error == "Token has expired" || error == "unauthorize")
      history.replace("/login");
  }, [error]);
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("haraworks_token")) {
      const haraworksTokenFromUrl = urlParams.get("haraworks_token");
      setHaraworksToken(haraworksTokenFromUrl);
    } else {
      const token = api.getUser();
      if (!token) {
        history.replace("/login");
      } else {
        gotoPage();
      }
    }
  }, []);
  useEffect(() => {
    if (haraworksToken) {
      authUserFromHRW();
    }
  }, [haraworksToken]);
  // Loading...
  if (authenticating) return <div />;
  return <Route {...rest} render={(props) => <Component {...props} />} />;
}
export default function Main() {
  return (
    <div style={{ display: "flex" }}>
      <MainWrapper>
        <Switch>
          <Route exact path="/component" component={ShareComponent} />
          {componentRoutes
            .filter((r) => r.component != null)
            .map((cpn) => (
              <Route
                key={cpn.path}
                exact
                path={cpn.path}
                component={cpn.component}
              />
            ))}
          <Route exact path="/portal" component={Portal} />
          <Route exact path="/portal_success" component={PortalSuccess} />
          <Route exact path="/login" component={Login} />
          <PrivateRoute {...{ component: Home, exact: true, path: "/" }} />
          <PrivateRoute
            {...{
              component: ResetPassword,
              exact: true,
              path: PagePath.RESET_PASSWORD,
            }}
          />
          <PrivateRoute
            {...{ component: Sites, exact: true, path: "/sites" }}
          />
          <PrivateRoute
            {...{
              component: SiteEdit,
              exact: true,
              path: "/sites/create",
              isCreate: true,
            }}
          />
          <PrivateRoute
            {...{
              component: SiteDetail,
              exact: true,
              path: "/site/:location_id",
            }}
          />
          <PrivateRoute
            {...{
              component: SiteEdit,
              exact: true,
              path: "/site/:location_id/edit",
            }}
          />
          <PrivateRoute
            {...{
              component: TrafficScanning,
              exact: true,
              path: "/site/:location_id/traffic_scanning",
            }}
          />
          <PrivateRoute
            {...{
              component: MarketInformation,
              exact: true,
              path: "/market_information",
            }}
          />
          <PrivateRoute
            {...{
              component: MarketInformationEdit,
              exact: true,
              path: "/market_information/create",
              isCreate: true,
            }}
          />
          <PrivateRoute
            {...{
              component: MarketInformationDetail,
              exact: true,
              path: `${PagePath.MARKET_INFORMATION}/:location_id`,
            }}
          />
          <PrivateRoute
            {...{
              component: MarketInformationEdit,
              exact: true,
              path: "/market_information/:location_id/edit",
            }}
          />
          <PrivateRoute
            {...{
              component: ExternalSites,
              exact: true,
              path: "/external_sites",
            }}
          />
          <PrivateRoute
            {...{
              component: ExternalSiteDetail,
              exact: true,
              path: "/external_site/:external_site_id",
            }}
          />
          <PrivateRoute
            {...{
              component: ExternalSiteEdit,
              exact: true,
              path: "/external_site/:external_site_id/edit",
            }}
          />
          <PrivateRoute
            {...{
              component: EstimateEBITDATC,
              exact: true,
              path: "/site/:location_id/estimate-ebitda-tc",
            }}
          />
          <PrivateRoute {...{ component: Map, exact: true, path: "/map" }} />
          <PrivateRoute
            {...{ component: MapComponent, exact: true, path: "/m" }}
          />
          {/* 
            // Store router 
          */}
          <PrivateRoute
            {...{
              component: StoreDetail,
              exact: true,
              path: "/store/:store_id/",
            }}
          />
          <PrivateRoute
            {...{
              component: StoreEdit,
              exact: true,
              path: "/store/:store_id/edit",
            }}
          />
          <PrivateRoute
            {...{ component: StoreManager, exact: true, path: PagePath.STORE }}
          />
          {/* <PrivateRoute
            {...{ component: StoreListing, exact: true, path: PagePath.STORE }}
          /> */}
          {/*
            // Site router
          */}
          <PrivateRoute
            {...{ component: SiteManager, exact: true, path: PagePath.SITE_2 }}
          />
          <PrivateRoute
            {...{
              component: SiteV2Detail,
              exact: true,
              path: "/sitev2/:site_id/",
            }}
          />
          <PrivateRoute
            {...{
              component: SiteV2Edit,
              exact: true,
              path: "/sitev2/:site_id/edit",
            }}
          />
          <PrivateRoute
            {...{ component: SiteV2Edit, exact: true, path: "/sitev2-create/" }}
          />
          <PrivateRoute
            {...{
              component: SiteComparison,
              exact: true,
              path: "/sitev2/:site_id/comparison",
            }}
          />
          <PrivateRoute
            {...{
              component: SiteTrafficCounting,
              exact: true,
              path: "/sitev2/:site_id/traffic/count",
            }}
          />
          <PrivateRoute
            {...{
              component: GoogleMap,
              exact: true,
              path: "/planning/map",
            }}
          />
          <PrivateRoute
            {...{
              component: PlanningMap,
              exact: true,
              path: "/planning/mapbox",
            }}
          />
          <PrivateRoute
            {...{
              component: StorePlanningList,
              exact: true,
              path: "/planning/list",
            }}
          />
          <PrivateRoute
            {...{
              component: SiteEstimateEBITDATC,
              exact: true,
              path: "/sitev2/:site_id/estimate-ebitda-tc",
            }}
          />
          <PrivateRoute
            {...{
              component: Settings,
              exact: true,
              path: "/settings",
            }}
          />
          <PrivateRoute
            {...{
              component: ZoneElement,
              exact: true,
              path: "/settings/zone/element",
            }}
          />
          <PrivateRoute
            {...{
              component: StatusManagement,
              exact: true,
              path: "/settings/status",
            }}
          />
          <PrivateRoute
            {...{
              component: UserListing,
              exact: true,
              path: "/settings/users",
            }}
          />
          {/* Help page */}
          <PrivateRoute
            {...{
              component: Help,
              exact: true,
              path: "/help",
            }}
          />
          <PrivateRoute
            {...{
              component: CustomTabs,
              exact: true,
              path: "/settings/custom-field",
            }}
          />
          <PrivateRoute
            {...{
              component: CustomTabDetail,
              exact: true,
              path: "/settings/custom-field/:tab_id",
            }}
          />
          <PrivateRoute
            {...{
              component: IFRS,
              exact: true,
              path: "/finance/ifrs",
            }}
          />
          <PrivateRoute
            {...{
              component: IFRSDetail,
              exact: true,
              path: "/finance/ifrs/:contract_id",
            }}
          />
          <PrivateRoute
            {...{
              component: Contract,
              exact: true,
              path: "/contract/:site_id",
            }}
          />
          <PrivateRoute
            {...{
              component: Revenue,
              exact: true,
              path: "/finance/revenue/:site_id",
            }}
          />
        </Switch>
        <ToastContainer position="top-right" autoClose={1000} pauseOnHover />
      </MainWrapper>
    </div>
  );
}
